import { styled } from '@mui/material/styles';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import { ChartPalette } from 'components/charts/types/chart-palette.type';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  overflowX: 'auto',
  paddingLeft: theme.spacing(4),
}));

const Tab = styled(NavLink, {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ theme, chartPalette }) => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 600,
  padding: theme.spacing(2, 4),
  textDecoration: 'none',
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,

  '&.active': {
    color: chartPalette.text.primary,
    backgroundColor: chartPalette.backgrounds.sunken,
  },
}));

const BenchmarkAnalyticsSubTabs: React.FC = () => {
  const chartPalette = useChartPalette();

  return (
    <Root>
      <Tab chartPalette={chartPalette} exact to="/benchmark-analytics/growth">
        <FormattedMessage id="benchmarkAnalytics.growth" />
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/benchmark-analytics/placeholder-one">
        <FormattedMessage id="benchmarkAnalytics.placeholderOne" />
      </Tab>
      <Tab chartPalette={chartPalette} exact to="/benchmark-analytics/placeholder-two">
        <FormattedMessage id="benchmarkAnalytics.placeholderTwo" />
      </Tab>
    </Root>
  );
};

export default React.memo(BenchmarkAnalyticsSubTabs);
